var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4247 0C27.676 0 30.6 3.026 30.6 8.211V25.772C30.6 31.042 27.676 34 22.4247 34H8.177C3.009 34 0 31.042 0 25.772V8.211C0 3.026 3.009 0 8.177 0H22.4247ZM8.636 23.358C8.126 23.307 7.633 23.545 7.361 23.987C7.089 24.412 7.089 24.973 7.361 25.415C7.633 25.84 8.126 26.095 8.636 26.027H21.964C22.6423 25.959 23.154 25.3793 23.154 24.701C23.154 24.004 22.6423 23.426 21.964 23.358H8.636ZM21.964 15.6043H8.636C7.9033 15.6043 7.31 16.201 7.31 16.932C7.31 17.663 7.9033 18.258 8.636 18.258H21.964C22.695 18.258 23.29 17.663 23.29 16.932C23.29 16.201 22.695 15.6043 21.964 15.6043ZM13.7173 7.905H8.636V7.922C7.9033 7.922 7.31 8.517 7.31 9.248C7.31 9.979 7.9033 10.574 8.636 10.574H13.7173C14.45 10.574 15.045 9.979 15.045 9.2293C15.045 8.5 14.45 7.905 13.7173 7.905Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b1e557dc0baf360019e7721030c49f30.svg";
export { ForwardRef as ReactComponent };